import { Value, AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

export interface RetirementInterface {
  clientData: RetirementIncome;
  partnerData?: RetirementIncome;
  extraIncome?: {
    type: string;
    title: string;
    value: AmountValue;
  }[];
  totalIncome: Value;
  options?: Options;
}

interface Options {
  currency: Currency[];
  calculationMode: string[];
  insuranceCalculationMode: string[];
  extraIncomeType: string[];
}

interface RetirementIncome {
  birthDate: string;
  calculatedPension: AmountValue;
  calculationMode: string;
  calculatedRetirementAge: {
    years: number;
    months: number;
  };
  insuranceRent: AmountValue;
  insuranceRentCalculationMode?: string;
  plannedPension: AmountValue;
  plannedRetirementAge: {
    years: number;
    months: number;
  };
  retired: boolean;
}

export const defaultValue = (currency: Currency) => ({
  value: 0,
  currency: currency
});

const defaultYrsMnth = {
  years: 0,
  months: 0,
};

const retirementDataDefault = (currency: Currency, partner: boolean) => ({
  birthDate: '',
  calculatedPension: defaultValue(currency),
  calculatedRetirementAge: defaultYrsMnth,
  calculationMode: '',
  insuranceRent: defaultValue(currency),
  // TODO: check
  //insuranceRentCalculationMode: partner ? undefined : '',
  plannedPension: defaultValue(currency),
  plannedRetirementAge: defaultYrsMnth,
  retired: false,
});


export const getInitialValues = (partner: boolean, currency: Currency): RetirementInterface => ({
  clientData: retirementDataDefault(currency, partner),
  partnerData: partner ? retirementDataDefault(currency, partner) : undefined,
  totalIncome: defaultValue(currency),
  extraIncome: [{ title: '', type: '', value: defaultValue(currency)  }],
});
